/**
 *   This is a service for a specific store module.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */
import Api from '@/services/api';

export default {

  async getDashboardCareers() {
    return Api().get('/dashboard/list_careers');
  },

  async getSubjectsByCareer(config: {params: { careerId: number }}) {
    return Api().get('/dashboard/list_subjects_by_career', config);
  },

  async getDashboardQuote() {
    return Api().get('/dashboard/list_quote');
  },

  async dashboardCareerCreate(params: { id: number; }) {
    return Api().post('/dashboard/career_create', params);
  },

  async dashboardCareerDelete(params: { id: number; }) {
    return Api().post('/dashboard/career_delete', params);
  },
  
};
